<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('home.item')}}</div>
			<!-- <div class="msg" @click="$router.push('/notice')">
				<img src="../images/invest/msg.png">
			</div> -->
		</div>
		<div class="item_wrap">
			<div class="tabs">
				<div class="tabs-head">
					<div class="tabs-head-scroll">
						<div class="tab-item" :class="active==index?'tab-item-active':''" v-for="(item,index) in tabs1"
							@click="sort(index)">
							<!-- <div class="tab-icon">
								<img :src="item.icon" alt="">
							</div> -->
							<div class="tab-title">
								{{item.title}}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="items_3 item_margin">
				<van-empty v-if="listLength == 0" :description="$t('item.noData')" />
				<div v-for="i in data.list" :key="i.id" class="item">
					<div class="item_div1" @click="$router.push('/item/'+i.id)">
	<!-- 
							<img v-if="i.cover" class="icon round" :src="i.cover" alt="">
							<img v-else class="icon round" src="../images/invest/bi.png" alt=""> -->
							<p>
								{{ i[lang] }}
							</p>
						</div>
						<div class="item_div2" @click="$router.push('/item/'+i.id)">
							<div class="item_day">
								<p>{{i.day}}{{$t('utils.day')}}</p>
								<p>{{$t('utils.cycle')}}</p>
							</div>
							<div class="item_rate">
								<p>{{i.rate}}%</p>
								<p>{{$t('utils.dailyIncome')}}</p>
							</div>
							<div class="circle-cell wow bounce animated infinite duration" data-wow-delay="2s">
								<van-circle v-model="i.percent" rate="30" speed="100" size="60px" layer-color="#e8e9ec" stroke-width="50" color="#ec5232"/>
								<div class="item_rate2" @click="$router.push('/item/'+i.id)" style="width:100%;">
									<p>{{i.percent}}%</p>
								</div>
							</div>
							<!-- <div class="item_progress">
								<div class="progress_bd">
									<van-progress :percentage="i.percent" stroke-width="4.5" track-color="#b8b8b8"
										color="#eb4718" :show-pivot="false" />
								</div>
								<span>{{i.percent}}%</span>
							</div> -->
						</div>
						<!-- <div class="item_div3">
							<span>{{$t('utils.scale')}}:{{i.total}}</span>
							<span>   按日收益，到期还本</span>
						</div> 
						
							<div class="item_day">
								<p>{{i.day}}{{$t('utils.day')}}</p>
								<p>{{$t('utils.cycle')}}</p>
							</div>
					
					-->
						<div class="item_div2">
							<div class="item_min">
								<p>{{i.min}}</p>
								<p>{{$t('utils.startingAmount')}}</p>
							</div>
							<div class="item_day">
								<p>{{i.max}}</p>
								<p>{{$t('utils.endingAmount')}}</p>
							</div>
							<div class="item_btn">
								<button v-if="i.percent<100" type="button" @click="$router.push('/item/'+i.id)">{{$t('utils.invest')}}</button>
								<button v-if="i.percent>=100" class="item_btn_over"
									type="button">{{$t('utils.investOver')}}</button>
								<p class="vipcon">{{i.m_name}}</p>
							</div>
						</div>
				</div>
			</div>
			<van-dialog v-model="show_tz" theme="round-button" @confirm="confirm1"
				:confirmButtonText="$t('utils.confirm')">
				<div class="close-x" @click="show_tz = false">
					<van-icon name="cross" />
				</div>
				<div class="show-body">
					<div class="sw-cell">
						<div class="sw-label">{{ sku[lang] }}</div>
						<div class="sw-bar">
							<div class="flex_bd">
								<van-field v-model="number" type="number" :placeholder="$t('item.inputAmount')" />
							</div>
							<div class="ut">USDT</div>
						</div>
					</div>
					<div class="sw-grid">
						<div class="flex_bd">
							<div class="sw-row">
								<div class="sw-info">{{$t('utils.yuji_sy')}}</div>
								<div class="sw-val">{{(sku.rate*number/100).toFixed(5)}}</div>
							</div>
							<div class="sw-row">
								<div class="sw-val text-green">{{sku.rate}}% [ USD ]</div>
								<div class="sw-info">{{$t('utils.cankao_info')}}</div>
							</div>
						</div>
						<div class="sw-right">
							<div class="sw-label">USDT</div>
							<div class="sw-lg">{{sku.day}}{{$t('utils.day')}}</div>
							<div class="sw-info">{{$t('utils.cycle')}}</div>
						</div>
					</div>
				</div>
				

			</van-dialog>
		
		</div>
		<van-dialog v-model="show_ht" theme="round-button" @confirm="confirm" :confirmButtonText="$t('utils.confirm')"  style="top:50%;">
			
			<div class="show-tc-body">
				<div class="popup" v-html="hetongContent"></div>
			</div>
			
		</van-dialog>
	</div>
</template>
<script>
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	import {WOW} from 'wowjs'
	import Vue from 'vue';
	import {
		Tab,
		Tabs,
		Progress,
		Empty,
		Dialog,
		Field,
		Circle,
		Sticky,
		Switch
	} from 'vant';
	Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field).use(Circle).use(Sticky).use(Switch);
	export default {
		name: "item",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				tabs: [
					this.$t('item.all'),
					this.$t('item.tab1'),
					this.$t('item.tab2'),
					this.$t('item.tab3'),
					this.$t('item.tab4'),
					this.$t('item.tab5')
				],
				tabs1: [{
					icon: require('../images/invest/icon1.png'),
					title: this.$t('item.all')
				}, {
					icon: require('../images/invest/icon2.png'),
					title: this.$t('item.tab1')
				}, {
					icon: require('../images/invest/icon3.png'),
					title: this.$t('item.tab2')
				}, {
					icon: require('../images/invest/icon4.png'),
					title: this.$t('item.tab3')
				}, {
					icon: require('../images/invest/icon1.png'),
					title: this.$t('item.tab4')
				}, {
					icon: require('../images/invest/icon2.png'),
					title: this.$t('item.tab5')
				}],
				active: 0,
				auto_close: [],
				data: [],
				listLength: 0,
				show_tz: false,
				show_ht: false,
				number: "",
				sku: [],
				checked: true,
				hetongContent:'',
				usinfo:{}
			}
		},
		created() {
			this.$parent.footer('item');
		},
		mounted() {
			var type = 0;
			if (this.$router.history.current.query.type) {
				this.active = parseInt(this.$router.history.current.query.type);
			}
			this.start(type);
			this.getHeTong();
			this.getUserInfo();
		},
		methods: {
			getHeTong(){
				Fetch('/index/article_detail', {
					id: 15
				}).then(res => {
					this.hetongContent = res.data.content;
				})
			},
			getUserInfo(){
				Fetch('/user/info').then(res => {
					this.usinfo = res.data;
				})
			},
			start(type) {
				Fetch('/index/item_search', {
					name: "",
					index_type: type
				}).then(r => {
					this.data = r.data;
					this.listLength = r.data.list.length;
				})
				Fetch('/index/item_auto').then((r) => {
					for (var i = 0; i < r.data.ids.length; i++) {
						this.auto_close.push(parseInt(r.data.ids[i]));
					}
				});
			},
			sort(type) {
				this.active = type
				this.start(type);
			},
			changeAuto(e)
			{
				console.log(e)
				Fetch("/index/item_auto_c", {
				  pid: this.sku.id,
				  tz_auto: this.checked?1:0
				}).then(r => { 
				}).catch(err=>{
				    this.psd_val = '';
				})
			},
			buy(item) {
				this.sku = item;
				if (this.auto_close.indexOf(item.id) != -1) {
					this.checked = false;
				} else {
					this.checked = true;
				}
				this.show_tz = true;
			},
			confirm() {
				if (!this.number) {
					this.$toast({
						className:"toastName",
						message: this.$t('item.inputAmount'),
					});
					return false;
				}
				Fetch("/index/item_apply", {
					id: this.sku.id,
					money: this.number
				}).then(r => {
					this.$router.push("/order");
				}).catch(err => {
					// this.psd_val = '';
				})
			},
			confirm1(){
				if(!this.number){
					this.$toast({
						className:"toastName",
						message: this.$t('item.inputAmount'),
					});
					return false;
				}
				/*<div class="sw-label">{{$t('utils.pro_name')}}:<span>{{sku[lang]}}</span></div>
				<div class="sw-label">{{$t('utils.tz_name')}}:<span>{{sku[lang]}}</span></div>
				<div class="sw-label">{{$t('utils.pro_company')}}:<span>{{sku[projector]}}</span></div>
				<div class="sw-label">{{$t('utils.db_company')}}:<span>{{sku[db_complany]}}</span></div>
				<div class="sw-label">{{$t('utils.investmentAmount')}}:<span>{{number}} USDT</span></div>
				<div class="sw-label">{{$t('utils.yuji_sy2')}}:<span>{{(sku.rate*number/100).toFixed(5)}} USDT</span></div>*/

				let htmlcon='';
				htmlcon+='<table cellpadding="1" cellspacing="0" bgcolor="#cccccc" width="100%">';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff" valign="top">' + this.$t('utils.pro_name')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + this.sku[this.lang] + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff">' + this.$t('utils.tz_name')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + this.usinfo.name + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff">' + this.$t('utils.pro_company')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + this.sku.projector + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff">' + this.$t('utils.db_company')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + this.sku.db_complany + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff">' + this.$t('utils.investmentAmount')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + this.number + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff">' + this.$t('utils.yuji_sy2')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + (this.sku.rate*this.number/100).toFixed(5) + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<table>';

				//章
				let zhangcon='';
				zhangcon+='<table cellpadding="0" cellspacing="0" width="100%">';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">' + this.$t('utils.zhang_jia') + this.$t('utils.pro_company') +'</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top"><img src="' + this.sku.zhang +'" width="100" height="100" /></td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">' + this.$t('utils.zhang_yi') +'</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">' + this.usinfo.name +' </td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">' + this.$t('utils.zhang_db') + this.$t('utils.db_company') +'</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top"><img src="' + this.sku.db_zhang +'" width="100" height="100" /></td>';
				zhangcon+='</tr>';
				zhangcon+='<table>';
				this.hetongContent = htmlcon + this.hetongContent + zhangcon;
				this.show_ht=true;
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/ .van-cell {
		padding: 15px 26px;
	}
	.items_3 .item .item_div2 div p.vipcon{
		color: #fefefe;
		background-color: #ea0707;
		border-radius: 10px;
		margin: 5px auto 0;
		padding: 2px;
		font-size: 12px;
	}

	.tabs {
		background-color: #1c074b;
		padding: 16px 0 10px 0;
		//border-bottom: 1px solid #ececec;
		position: fixed;
		width: 100%;
	}

	.tabs-head {
		height: 23px;
		overflow: hidden;
		position: relative;

		.tabs-head-scroll {
			width: 100%;
			height: 30px;
			overflow: scroll;
			white-space: nowrap;

			.tab-item {
				display: inline-block;
				text-align: center;
				//width: 25%;
				padding: 0 11px;
				// margin-right: 28px;

				.tab-icon {
					height: 51px;

					img {
						height: 100%;
					}
				}

				.tab-title {
					padding: 5px 0;
					color: #666666;
				}
			}

			.tab-item-active {
				.tab-title {
					color: #ffffff;
				}
			}
		}
	}

	.red_top_bg {
		position: fixed;
		top: 0;
		z-index: 10;
		background-color: #250767;
		//background-image: linear-gradient(to right, #ff5252, #ff8244);

		.msg {
			position: absolute;
			top: 15px;
			right: 15px;
			height: 18px;

			img {
				height: 100%;
			}
		}
	}

	.basic_wrap {
		position: relative;
		background-color: #250767;
	}

	.item_wrap {
		width: 100%;
		padding: 44px 0 0 0;

		.tabs {
			z-index: 100;
		}
	}

	/*.item_margin {
		margin-top: 109px !important;
	}*/

	.items_3 {
		margin: 60px 15px 10px;

		.item {
			background: #261057;
		}
	}

	.items_3 {
		.item {
			margin-bottom: 10px;
			border-radius: 10px;
			overflow: hidden;
			//border: 1px solid #2e116d;
			//box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);

			// div{
			// 	margin: 5px 0;
			// }
			.item_div1 {
				display: flex;
				min-height: 40px;
				line-height: 25px;
				align-items: center;
				//border-bottom: 1px solid #2e116d;
				padding: 4px 10px;
				//background-color: #2e116d;

				p {
					// width: 90%;
					//font-weight: bold;
					overflow: hidden;
					//text-overflow: ellipsis;
					//white-space: nowrap;
					font-size: 15px;
					color: #ffffff;
				}

				.icon {
					width: 32px;
					height: 32px;
					margin-right: 8px;
				}
			}

			.item_div2 {
				display: flex;
				justify-content: space-between;
				text-align: center;
				padding: 12px 0;
				font-size: 14px;

				div {
					width: 33.33%;

					p {
						padding: 5px 0;
					}
				}

				.item_rate {
					p:nth-child(1) {
						font-weight: bold;
						color: #FFffff;
						font-size: 15px;

					}

					p:nth-child(2) {
						color: #999;
						font-size: 14px;
					}
				}

				.item_day {
					p:nth-child(1) {
						color: #FFffff;
						font-weight: bold;
						font-size: 15px;
					}

					p:nth-child(2) {
						color: #999;
						font-size: 14px;
					}
				}

				.item_min {
					p:nth-child(1) {
						color: #FFffff;
						font-weight: bold;
						font-size: 15px;

					}

					p:nth-child(2) {
						color: #999;
						font-size: 14px;
					}
				}
				
				.item_btn {
					//width: 24%;
					//text-align: right;

					button {
						min-width: 65px;
						color: #f44844;
						padding: 6px;
						border-radius: 5px;
						font-size: 13px;
						border: 1px solid #e82637;
					}

					.item_btn_over {
						color: #999;
						border: 1px solid #999;
					}
				}
			}

			.item_div3 {
				color: #999;
				padding: 0 12px;
			}

			.item_div4 {
				padding: 0 12px 10px;
				display: flex;
				align-items: center;
				justify-content: space-between;


				.item_progress {
					width: 71%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					//background-color: #e9e9e9;
					padding: 0 4px;
					border-radius: 12px;

					.progress_bd {
						width: 75%;
					}

					span {
						color: #e82637;
					}

				}

				.item_btn {
					width: 24%;
					text-align: right;

					button {
						min-width: 65px;
						color: #f44844;
						padding: 6px;
						border-radius: 5px;
						font-size: 13px;
						border: 1px solid #e82637;
					}

					.item_btn_over {
						color: #999;
						border: 1px solid #999;
					}
				}
			}
		}
	}

	/deep/ .van-tabs__line {
		height: 2px;
		background-color: #1989fa;
	}

	/deep/ .van-tab--active {
		color: #1989fa;
	}

	.show-body {
		padding: 20px;
		font-size: 14px;

		.sw-label {
			margin-bottom: 10px;
		}

		.sw-bar {
			display: flex;
			align-items: center;
			background-color: #f5f5f5;
			padding: 10px;
			border-radius: 4px;

			.flex_bd {
				color: #999999;
			}
		}
	}

	.sw-bar .van-cell {
		padding: 0;
		background-color: transparent;
	}

	.sw-grid {
		display: flex;
		align-items: flex-end;
		margin-top: 20px;

		.sw-row:first-child {
			margin-bottom: 20px;
		}

		.sw-row>div:first-child {
			margin-bottom: 10px;
		}

		.sw-info {
			color: #999;
		}

		.sw-val.text-green {
			font-size: 16px;
		}
	}

	.sw-right {
		text-align: center;

		.sw-lg {
			font-size: 24px;
			margin-bottom: 10px;
		}
	}

	.flex_bd {
		flex: 1;
	}
	
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 80vh;
		padding: 26px 24px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}
	
	.circle-cell{
		display: flex;
		justify-content: center;
		position: relative;
		margin-bottom: 10px;
		.item_rate{
			margin: 0!important;
			text-align: center;
			width: 100%;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
		}
		.item_rate2{
			margin: 0!important;
			text-align: center;
			width: 100%;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			font-size: 12px;
			color: #ffffff;
		}
	}
	
	.animated.infinite {
	    -webkit-animation-iteration-count: infinite;
	    animation-iteration-count: infinite;
	}
	
	.animated.duration {
	    -webkit-animation-duration: 2s;
	    animation-duration: 2s
	}
</style>
